import { useNavigate } from 'react-router-dom'

import orderBy from 'lodash/orderBy'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import users from 'modules/core/store/collections/users'

import NavigationSlider from 'modules/reports/components/NavigationSlider'
import dashboards from 'modules/reports/store/collections/dashboards'
import favouriteDashboards from 'modules/reports/store/collections/favourite_dashboards'
import type FavouriteDashboard from 'modules/reports/store/models/FavouriteDashboard'

import Item from './_Item'

const FavouriteSelector = () => {
  const { navigation } = useNavigation()

  const navigate = useNavigate()

  const favourites = favouriteDashboards.filter({
    author_id: users.current.id,
  })

  const getDashboard = (favourite: FavouriteDashboard) => {
    return dashboards.find({
      id: favourite.attributes.dashboard_id,
    })
  }

  const orderedFavourites = orderBy(
    favourites,
    [
      (favourite: FavouriteDashboard): string =>
        getDashboard(favourite)?.attributes.updated_at || '',
    ],
    ['desc']
  )

  const onSelectIndex = (index: number) => {
    const id = orderedFavourites[index]?.attributes.dashboard_id

    navigate(navigation.reports.dashboards.dashboardId.list.fullPath({ dashboard_id: id }))
  }

  const renderItem = (index: number) => {
    const rendered = orderedFavourites[index]

    if (!rendered) return null

    const dashboard = getDashboard(rendered)

    if (!dashboard) return null

    return <Item key={dashboard.id} dashboard={dashboard} />
  }

  return (
    <NavigationSlider
      renderItem={renderItem}
      items={orderedFavourites}
      selectedIndex={-1}
      onSelectIndex={onSelectIndex}
    />
  )
}

export default observer(FavouriteSelector)
